// ---------------------------------------------
// Hover Image Switcher for Header Mega Menu
// ---------------------------------------------
function setupHoverImageSwitcher() {
  const links = document.querySelectorAll(".header__menu-item");
  const images = document.querySelectorAll(".mega-menu__inner-image");

  if (!links.length || !images.length) return;

  function showImage(target) {
    images.forEach(img => {
      img.classList.remove("active");
      if (img.dataset.menuImage === target) {
        img.classList.add("active");
      }
    });
  }

  showImage("default"); // Show default on load

  links.forEach(link => {
    const target = link.getAttribute("aria-label");
    if (!target) return;

    link.addEventListener("mouseenter", () => showImage(target));
    link.addEventListener("mouseleave", () => showImage("default"));
  });
}


// ---------------------------------------------
// Filter Cleanup for Resources Page
// ---------------------------------------------


//function setupRegistryFilter() {
  //if (document.title.trim() !== "Resources – We Got This Dev") return;

  //const buttons = document.querySelectorAll('.filters__item');
  //const labelsToRemove = ["In stock only", "Price", "Brand"];

  //buttons.forEach(button => {
    //button.style.opacity = "0";
  //});

  //setTimeout(() => {
    //buttons.forEach(button => {
      //const text = button.textContent.trim();
      //if (labelsToRemove.some(label => text.includes(label))) {
       // button.remove();
      //} else {
       // button.style.opacity = "1";
      //}
    //});
  //}, 50);
//}


// ---------------------------------------------
// Inline Nav Sticky & ScrollSpy
// ---------------------------------------------
function setupInlineNav() {
  const nav = document.getElementById('inlineNav');
  const announcement = document.querySelector('.announcement-bar');
  const header = document.querySelector('.header');  // Targeting .header for its height
  const sectionWrapper = nav?.closest('.shopify-section');
  const nextElement = sectionWrapper?.nextElementSibling || null;

  if (!nav || !announcement || !header) return;

  let navOffset = 0;
  let announcementBarHeight = 0;
  let headerHeight = 0;

  console.log('header', header)
  console.log('annoucement', announcement)

  // Update the offsets for both the announcement bar and header height
  const updateOffsets = () => {
    announcementBarHeight = announcement.offsetHeight;
    headerHeight = header.offsetHeight;
    navOffset = nav.getBoundingClientRect().top + window.pageYOffset - (announcementBarHeight + headerHeight);  // Adjusted to include header height
  console.log('announcement bar height', announcementBarHeight);
  console.log('header height', headerHeight);
  };

  window.addEventListener('resize', updateOffsets);
  updateOffsets(); // Run once initially to get correct offsets

  // Scroll behavior for sticky navigation
  window.addEventListener('scroll', function () {
    if (window.scrollY >= navOffset) {
      nav.classList.add('fixed');
      if (nextElement) {
        nextElement.style.marginTop = `${nav.offsetHeight}px`;
      }
    } else {
      nav.classList.remove('fixed');
      if (nextElement) {
        nextElement.style.marginTop = '0';
      }
    }
  });

  // Smooth scroll for internal links
  const navLinks = document.querySelectorAll('#inlineNav a[href^="#"]');
  navLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').slice(1);
      const target = document.getElementById(targetId);
      if (!target) return;

      const offset = announcementBarHeight + headerHeight + nav.offsetHeight;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: targetPosition - offset,
        behavior: 'smooth'
      });
    });
  });

  // ScrollSpy: Highlight active nav link based on section visibility
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const sectionId = entry.target.id;
      const link = document.querySelector(`#inlineNav a[href="#${sectionId}"]`);

      if (entry.isIntersecting && link) {
        navLinks.forEach(l => l.classList.remove('is--active'));
        link.classList.add('is--active');
      }
    });
  }, {
    rootMargin: '-20% 0px -70% 0px', // Adjust this margin for better control of when the sections are considered "active"
    threshold: 0
  });

  navLinks.forEach(link => {
    const targetId = link.getAttribute('href')?.slice(1);
    const section = document.getElementById(targetId);
    if (section) observer.observe(section);
  });

  updateOffsets();
}




// ---------------------------------------------
// Shop Grid Column Adjuster (Sidebar Filter Toggle)
// ---------------------------------------------
function setupShopGrid() {
  const filterButton = document.querySelector('button.shop__filters-btn[data-sidebar-id="SidebarFiltersDesktop"]');
  const productGrid = document.getElementById('ShopProductsGrid');

  if (!filterButton || !productGrid) return;

  function updateGridColumns() {
    const isFilterOpen = filterButton.classList.contains('is-opened');
    productGrid.style.setProperty('--gsc-desktop-columns', isFilterOpen ? '3' : '4');
  }

  updateGridColumns();

  const observer = new MutationObserver(() => {
    updateGridColumns();
  });

  observer.observe(filterButton, {
    attributes: true,
    attributeFilter: ['class'],
  });
}





// ---------------------------------------------
// Sticky Sidebar
// ---------------------------------------------
function setupStickySidebar() {
  const stickyElement = document.querySelector('.aside-sticky');
  if (!stickyElement) return;

  const stickyOffset = stickyElement.offsetTop;

  window.addEventListener('scroll', function () {
    if (window.scrollY >= stickyOffset) {
      stickyElement.classList.add('fixed');
    } else {
      stickyElement.classList.remove('fixed');
    }
  });
}

// ---------------------------------------------
// Newsletter
// ---------------------------------------------
(function () {
  if (window.location.pathname !== "/pages/newsletter") return;

  const INTERVAL = 200;
  const TIMEOUT = 5000;
  let waited = 0;

  const THRIVER_FIELD_IDS = [
    "rich-text-01JV4JMZNCDRVVNHG7EQVCVG77", // "About Your Journey as a Cancer Thriver" heading
    "Year_of_diagnose_01JV4JMZNK0VPGFZG2YPRTRBXQ",
    "Cancer_type_01JTV1V7HKS5WSZCQY8JX6AP8B",
    "Treatment__10__21", // and all other checkboxes under "Treatment__10"
    "Treatment__10__22",
    "Treatment__10__23",
    "Treatment__10__24",
    "Treatment__10__25",
    "Cancer_story_01JV4JMZP43T4TA6HF9FZVF2BM"
  ];

  function hideElementById(id) {
    const el = document.getElementById(id);
    if (el) el.closest('[data-testid="form-row"]').style.display = "none";
  }

  function showElementById(id) {
    const el = document.getElementById(id);
    if (el) el.closest('[data-testid="form-row"]').style.display = "";
  }

  const tryInit = setInterval(() => {
    const form = document.querySelector("form");
    const thriverRadio = form?.querySelector('input[id="Thriver%2FSupporter__7__19"]');
    const supporterRadio = form?.querySelector('input[id="Thriver%2FSupporter__7__20"]');
    const thriverLabel = form?.querySelector('label[for="Thriver%2FSupporter__7__19"]');
    const supporterLabel = form?.querySelector('label[for="Thriver%2FSupporter__7__20"]');

    if (!form || !thriverRadio || !supporterRadio || !thriverLabel || !supporterLabel) {
      waited += INTERVAL;
      if (waited > TIMEOUT) clearInterval(tryInit);
      return;
    }

    clearInterval(tryInit);

    function updateVisibility() {
      const isThriver = thriverRadio.checked;
      THRIVER_FIELD_IDS.forEach(id => {
        if (isThriver) {
          showElementById(id);
        } else {
          hideElementById(id);
        }
      });
    }

    // Listen to label clicks (Klaviyo uses custom styles)
    [thriverLabel, supporterLabel].forEach(label => {
      label.addEventListener("click", () => setTimeout(updateVisibility, 100));
    });

    updateVisibility(); // initial run
  }, INTERVAL);
})();



// ---------------------------------------------
// Call functions
// ---------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
const dropdownBackdrop = document.querySelector('.header__dropdown-backdrop');

if (dropdownBackdrop) {
  const observer = new MutationObserver((mutationsList, obs) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'with-opened-dropdown'
      ) {
        const hasDropdownOpen = dropdownBackdrop.hasAttribute('with-opened-dropdown');
        if (hasDropdownOpen) {
          setupHoverImageSwitcher();
          obs.disconnect(); 
        }
      }
    }
  });

  observer.observe(dropdownBackdrop, {
    attributes: true 
  });
}

 // setupRegistryFilter();
  setupInlineNav();
  setupShopGrid();
  setupStickySidebar();
 
  //setupFaqNav();
  //setupFaqNavLinks();
});


function fixVendorLinks() {
  document.querySelectorAll('a[href*="filter.p.vendor"]').forEach(link => {
    try {
      const href = link.getAttribute('href');
      // Only process if the link contains a +
      if (href.includes('+') && !href.includes('%2B')) {
        const fixedHref = href.replace(/\+/g, '%2B').replace(/ /g, '%20');
        link.setAttribute('href', fixedHref);
      }
    } catch (e) {
      console.warn('Vendor link fix error:', e);
    }
  });
}

// Run on first load
document.addEventListener('DOMContentLoaded', fixVendorLinks);

// Run again if Shopify filters re-render
const observer = new MutationObserver(() => fixVendorLinks());
observer.observe(document.body, { childList: true, subtree: true });
